import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from "@nosto/preact"
import { useMemo } from "preact/hooks";
import { productImagePlaceholder, addToCart } from "../helpers"
import { formatCurrency } from "../currencies"

export default function ({ product, index }) {
    const { format } = useCurrencyFormatting();
    const badgeText = useMemo(() => product.tags1?.find(tag => tag.includes('badge:'))?.replace('badge: ', '') || undefined, []);
    const washesText = useMemo(() => product.tags1?.find(tag => tag.includes('+ Washes')) || undefined, []);
    const handle = useMemo(() => product.url.split('/products/')[1], []);
    const priceEl = useMemo(() => (
        <div class="price-container w-full flex items-center mb-3">
            {product.listPrice > product.price &&
                <>
                    <span class="sr-only visually-hidden">Original Price</span>
                    <span class="compare-price">{formatCurrency(product.listPrice)}</span>
                </>
            }
            <span class="sr-only visually-hidden">Price</span>
            <span class="final-price">{formatCurrency(product.price)}</span>
        </div>
    ), [])

    return (
        <SerpElement
            as="spark-product-card"
            hit={product}
            class="ns-product relative"
            parent-id={product.productId}
            style={`order: ${index}`}
        >
            <div parent-id={product.productId} class="ns-product-card h-full flex flex-col relative justify-between cursor-pointer" data-handle={handle}>
                <div class="product-media block relative !mb-3 md:!mb-4 overflow-hidden" tabindex="-1">
                    {/* <button class="product-card__quickview-trigger pl-3 pt-2" js-quick-view="toggle" data-product-url={product.url} js-quick-view="toggle">
                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.799975 24.1999L9.11746 15.8824" stroke="black" stroke-width="1.2" stroke-linecap="round"></path>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.4196 18.1608C10.6808 18.1608 6.83924 14.3192 6.83924 9.58038C6.83924 4.84157 10.6808 1 15.4196 1C20.1584 1 24 4.84157 24 9.58038C24 14.3192 20.1584 18.1608 15.4196 18.1608Z" stroke="black" stroke-width="1.2" stroke-linecap="round"></path>
                        </svg>
                    </button> */}

                    <a class="product-media-link product-link" href={product.url}>
                        <div class="product-media-inner w-full h-[219px] md:h-[354px] h-full flex items-stretch justify-center">
                            <div class="w-full flex flex-col items-center justify-center">
                                <div class="media media--transparent w-full media--adapt media--hover-effect" style="padding-bottom: 100%;">
                                    <img
                                        class="motion-reduce"
                                        loading="lazy"
                                        srcset={`
                                            ${product.imageUrl.replace('.jpg', '_165px.jpg').replace('.png', '_165px.png')} 165w,
                                            ${product.imageUrl.replace('.jpg', '_360x.jpg').replace('.png', '_360x.png')} 360w,
                                            ${product.imageUrl.replace('.jpg', '_533x.jpg').replace('.png', '_533x.png')} 533w,
                                            ${product.imageUrl.replace('.jpg', '_720x.jpg').replace('.png', '_720x.png')} 720w,
                                            ${product.imageUrl.replace('.jpg', '_940x.jpg').replace('.png', '_940x.png')} 940w,
                                            ${product.imageUrl.replace('.jpg', '_1066x.jpg').replace('.png', '_1066x.png')} 1066w
                                        `}
                                        height="1000"
                                        width="1000"
                                        sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"
                                        src={product.imageUrl ?? productImagePlaceholder}
                                        alt={product.name}
                                    />
                                </div>
                            </div>

                            {badgeText &&
                                <div class="badges">
                                    <div class="badge">{badgeText}</div>
                                </div>
                            }

                            <div class="product-cta-wrapper w-full desktop">
                                <div>
                                    {product.availability === 'OutOfStock'
                                        ?   <button 
                                                aria-label="Sold Out" 
                                                name="add" 
                                                type="button" 
                                                class="cta-btn sold-out-btn flex justify-center items-center w-full h-full text-center"
                                                disabled
                                            >
                                                Sold Out
                                            </button>
                                        :   <button 
                                                aria-label="Add to Cart"
                                                name="add" 
                                                type="button" 
                                                data-product={product.productId}
                                                data-variant={product.skus[0]?.id}
                                                onClick={addToCart}
                                                class="cta-btn flex justify-center items-center w-full h-full text-center"
                                            >
                                                {product.tags1?.includes('pre-order') ? 'Pre-Order' : 'Add to Cart'}
                                            </button>
                                    }
                                </div>
                            </div>
                        </div>
                    </a>
                </div>

                <div class="ns-card-details">
                    <div class="w-full flex flex-col justify-between items-stretch">
                        <h3 class="product-title block m-0">
                            <a class="product-title-link block product-link" href={product.url}>
                                {product.name}
                            </a>
                        </h3>

                        {washesText && 
                            <div class="card-information__attributes">
                                <div class="attribute">{washesText}</div>
                            </div>
                        }

                        {priceEl}

                        {/* <div class="price-container w-full flex items-center mb-3">
                            {product.listPrice > product.price &&
                                <>
                                    <span class="sr-only visually-hidden">Original Price</span>
                                    <span class="compare-price">{formatCurrency(product.listPrice)}</span>
                                </>
                            }
                            <span class="sr-only visually-hidden">Price</span>
                            <span class="final-price">{formatCurrency(product.price)}</span>
                        </div> */}

                    </div>
                    <div class="product-cta-wrapper w-full mobile">
                        <div>
                            {product.availability === 'OutOfStock'
                                ?   <button 
                                        aria-label="Sold Out" 
                                        name="add" 
                                        type="button" 
                                        class="cta-btn sold-out-btn flex justify-center items-center w-full h-full text-center"
                                        disabled
                                    >
                                        Sold Out
                                    </button>
                                :   <button 
                                        aria-label="Add to Cart"
                                        name="add" 
                                        type="button" 
                                        data-product={product.productId}
                                        data-variant={product.skus[0]?.id}
                                        onClick={addToCart}
                                        class="cta-btn flex justify-center items-center w-full h-full text-center"
                                    >
                                        {product.tags1?.includes('pre-order') ? 'Pre-Order' : 'Add to Cart'}
                                    </button>
                            }
                        </div>
                    </div>
                </div>

            </div>
        </SerpElement>
    )
}
